/**
 * Environment configuration accessor.
 *
 * Isolates `import.meta.env` (Vite-only syntax) into a single module so that
 * Jest can mock it via moduleNameMapper. Consuming code reads these constants
 * instead of touching `import.meta.env` directly.
 */

const env = import.meta.env;

export const WS_URL: string =
  env.VITE_WS_URL ?? env.VITE_WEBSOCKET_URL ?? 'ws://localhost:3002';

/**
 * Phase 7: API Gateway WebSocket endpoint (wss://...). When set, the
 * frontend connects here with `?token=<jwt>` instead of the legacy
 * direct-to-ECS WS_URL. Falls back to WS_URL for local dev.
 */
export const WS_API_URL: string | undefined = env.VITE_WS_API_URL;

export const API_URL: string = env.VITE_API_URL ?? '/api';

export const COGNITO_USER_POOL_ID: string | undefined =
  env.VITE_COGNITO_USER_POOL_ID;

export const COGNITO_CLIENT_ID: string | undefined =
  env.VITE_COGNITO_CLIENT_ID;

export const COGNITO_REGION: string | undefined =
  env.VITE_COGNITO_REGION;

export const isAuthConfigured: boolean = Boolean(
  COGNITO_USER_POOL_ID && COGNITO_CLIENT_ID
);
